import { useMemo } from "react";
import { useDragLayer } from "react-dnd";
import { useTranslation } from "react-i18next";
import Tooltip from "../../../../components/shared/Tooltip";
import { useScheduleContext } from "../hooks/context/useScheduleContext";
import { useDateFilters } from "../../../../components/shared/filters/DateFilters/context/useDateFilters";

const isMac = typeof navigator !== "undefined" && /Mac|iPhone|iPad|iPod/.test(navigator.platform ?? navigator.userAgent);
const COPY_MODIFIER_KEY = isMac ? "⌘" : "Ctrl";

function DragCopyTooltip() {
    const { t } = useTranslation();
    const { dragAndDropCopy } = useScheduleContext();
    const { mode } = useDateFilters();

    const { isDragging, clientOffset } = useDragLayer((monitor) => ({
        isDragging: monitor.isDragging(),
        clientOffset: monitor.getClientOffset()
    }));

    const label = useMemo(() => t("release-meta-to-copy", { key: COPY_MODIFIER_KEY }), [t]);

    if (!isDragging || !dragAndDropCopy || !clientOffset) {
        return null;
    }

    const verticalOffset = mode === "month" ? 15 : 35;

    return (
        <div
            className="tw-fixed tw-top-0 tw-left-0 tw-z-[99] tw-pointer-events-none"
            style={{
                transform: `translate(${clientOffset.x}px, ${clientOffset.y - verticalOffset}px)`
            }}
        >
            <Tooltip
                open
                side="top"
                trigger={<span className="tw-block tw-size-px" />}
                contentClassName="tw-bg-white tw-text-sm tw-text-neutral-900 tw-shadow-md tw-p-4"
            >
                {label}
            </Tooltip>
        </div>
    );
}

export default DragCopyTooltip;
